import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0f1f14] py-12 sm:py-16 lg:py-20 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 text-[#7cb342]/10 text-6xl sm:text-8xl lg:text-[160px] font-extrabold tracking-widest pointer-events-none select-none leading-none hidden sm:block">
        ARTACA
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 lg:mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/eb8228feaf53da6f20b3f98030813076.jpeg"
                alt="Artaca Tactic Panama"
                className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
              />
              <span className="text-white font-bold text-lg sm:text-xl whitespace-nowrap">
                ARTACA TACTIC
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              La tienda líder en equipamiento táctico y militar en Panamá. Calidad profesional garantizada para fuerzas de
              seguridad y profesionales.
            </p>
            <div className="flex items-center space-x-2 bg-[#7cb342]/15 border border-[#7cb342]/30 rounded-lg px-3 py-2">
              <i className="ri-truck-line text-[#7cb342] text-base w-4 h-4 flex items-center justify-center"></i>
              <span className="text-[#7cb342] text-xs sm:text-sm font-semibold">Se realiza delivery hasta el interior</span>
            </div>
          </div>

          <div>
            <h4 className="text-[#7cb342] text-xs font-semibold tracking-wider mb-4">NAVEGACIÓN</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white hover:text-[#7cb342] transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" className="text-white hover:text-[#7cb342] transition-colors text-sm">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white hover:text-[#7cb342] transition-colors text-sm">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/ubicacion" className="text-white hover:text-[#7cb342] transition-colors text-sm">
                  Ubicación
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#7cb342] text-xs font-semibold tracking-wider mb-4">CONTACTO</h4>
            <ul className="space-y-3 text-white text-sm">
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-[#7cb342] w-4 h-4 flex items-center justify-center"></i>
                <span>6535-8000</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#7cb342] w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                <span>Megamall Panamá, Kiosco #114</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-instagram-line text-[#7cb342] w-4 h-4 flex items-center justify-center"></i>
                <span>@artaca4</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#7cb342] text-xs font-semibold tracking-wider mb-4">SÍGUENOS</h4>
            <div className="flex space-x-3">
              <a
                href="https://instagram.com/artaca4"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 sm:w-12 sm:h-12 bg-[#1a3a2e] hover:bg-[#7cb342] rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://wa.me/50765358000"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 sm:w-12 sm:h-12 bg-[#1a3a2e] hover:bg-[#7cb342] rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1a3a2e] pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-xs sm:text-sm text-center sm:text-left">
            © 2025 Artaca Tactic Panama. Todos los derechos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-gray-500 hover:text-[#7cb342] text-xs sm:text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            Web Design
          </a>
        </div>
      </div>
    </footer>
  );
}
